export const logoutAction = () => ({
  type: "LOGOUT",
});
